import { useLocalSearchParams, useRouter } from 'expo-router';
import { useCallback } from 'react';

import { RecordingFullScreen } from '@/components/organisms/voice-recording';
import { useMeetingAnalyticsStore } from '@/stores/useMeetingAnalyticsStore';

const RecordingRoute = () => {
  const router = useRouter();
  const trackContactPickerShown = useMeetingAnalyticsStore(
    (state) => state.trackContactPickerShown,
  );
  const params = useLocalSearchParams<{
    contactId?: string;
    meetingId?: string;
    userId?: string;
    accountId?: string;
  }>();

  const handleMinimize = useCallback(() => {
    router.back();
  }, [router]);

  const handleMeetingCreated = useCallback(
    (meetingId: string, recordingSessionId: string | null) => {
      if (params.meetingId) {
        router.replace({ pathname: '/meeting/[id]', params: { id: meetingId } });

        return;
      }

      trackContactPickerShown({ meetingId, source: 'recording_flow', recordingSessionId });
      router.replace({
        pathname: '/meeting/[id]',
        params: { id: meetingId, openAttendeePicker: 'true' },
      });
    },
    [params.meetingId, router, trackContactPickerShown],
  );

  return (
    <RecordingFullScreen
      contactId={params.contactId ? Number(params.contactId) : undefined}
      meetingId={params.meetingId}
      userId={params.userId}
      accountId={params.accountId}
      onMinimize={handleMinimize}
      onMeetingCreated={handleMeetingCreated}
    />
  );
};

export default RecordingRoute;
